import { TenantEntity } from '../TenantEntity'
import { ApiCacheManage } from '@/utils/commonUtil'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'

// getDocCategoryTypeTreeByLob缓存管理
const getDocCategoryTypeTreeByLobCache = new ApiCacheManage(getDocCategoryTypeTreeByLob)

export class DocumentCategory extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get lob() {
    return this._data.lob
  }
  set lob(lob) {
    this._data.lob = lob
  }
  get level() {
    return this._data.level
  }
  set level(level) {
    this._data.level = level
  }
  get code() {
    return this._data.code
  }
  set code(code) {
    this._data.code = code
  }
  get name() {
    return this._data.name
  }
  set name(name) {
    this._data.name = name
  }
  get localName() {
    return this._data.localName
  }
  set localName(localName) {
    this._data.localName = localName
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  // 检查放账信息缓存
  static async getDocCategoryTypeTreeByLob(params) {
    return await getDocCategoryTypeTreeByLobCache.execute(params)
  }
  // 清理放账信息缓存
  static clearDocCategoryTypeTreeByLob() {
    getDocCategoryTypeTreeByLobCache.clear()
  }
}
